import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Settings & Content API
 * 
 * All endpoints use the base URL from VUE_APP_API_URL environment variable
 * Default: https://inversuncms.on-forge.com/api
 */

export const settingsApi = {
  /**
   * Get flat homepage content/settings payload.
   * @returns {Promise} Homepage key/value data
   */
  async getHomepageData() {
    const response = await apiClient.get(apiEndpoints.homepageData)
    return response.data
  },

  /**
   * Get settings by group
   * @param {string} group - Settings group name (e.g., 'general', 'contact', 'seo')
   * @returns {Promise} Settings object for the group
   */
  async getSettingsByGroup(group) {
    const response = await apiClient.get(apiEndpoints.settings.byGroup(group))
    return response.data
  },

  /**
   * Get all CMS pages
   * @returns {Promise} Pages list
   */
  async getPages() {
    const response = await apiClient.get(apiEndpoints.pages.list)
    return response.data
  },

  /**
   * Get single page by slug
   * @param {string} slug - Page slug (e.g., 'about', 'privacy-policy')
   * @returns {Promise} Page content
   */
  async getPage(slug) {
    const response = await apiClient.get(apiEndpoints.pages.detail(slug))
    return response.data
  },
}

export default settingsApi
